import { Alert, Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getUserRequest, ResetShoppingcart } from "../redux/actions";
import { cancelSubscriptionRequest, getSubscriptionRequest } from "../redux/actions/subscription";
import { AppState } from "../redux/types";
import { handleAppRedirect } from "../utils/url-helper";
import ConfirmDialog from "./confirmDialog/ConfirmDialog";
import Group from "./Group";
import Intro from "./Intro";
import OrderInfo from "./OrderInfo";

const Order = ({ onSelect }: any) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector((state: AppState) => state.user);
    const userId = useSelector((state: AppState) => state.user?.id);

    const user_subscription = useSelector((state: AppState) => state.subscription.get?.subscriptionData);
    const selectedServices = useSelector((state: AppState) => state.cart.inCart);
    const [showConfirm, setShowConfirm] = useState(false);
    //const orders = useSelector((state: AppState) => state.user.orders)
    //const isPaid = orders?.map((o: any) => o.isPaid)
    // @ts-ignore
    const order_id = new URLSearchParams(window.location.search).get("order_id");
    // console.log(order_id)
    if (!!order_id && selectedServices?.length) {
        dispatch(ResetShoppingcart());
    }
    const { orders } = user;
    const last_order = orders?.length ? orders.sort((a, b) => b.id - a.id)[0] : null;

    const handleShowDialog = () => {
        setShowConfirm(true);
    };

    const handleEndService = () => {
        dispatch(cancelSubscriptionRequest({ history: history }));
        setShowConfirm(false);
    };

    const isActiveSubscription = () => {
        if (user_subscription && (user_subscription.status === "active" || user_subscription.status === "trialing") && user.appOnly) {
            return true;
        }
        return false;
    };

    useEffect(() => {
        if (userId) {
            dispatch(getSubscriptionRequest(userId));
            dispatch(getUserRequest(userId));
        }
    }, [dispatch, userId]);

    return (
        <>
            {" "}
            {showConfirm ? (
                <div className="m-4">
                    <ConfirmDialog
                        title="Lopeta palvelu"
                        subtitle="Haluatko lopettaa Digihappy apin käytön?"
                        panelTitle="Haluatko varmasti lopettaa Digihappy palvelun?"
                        description="Sinun, seniorin ja läheisten tilit poistuvat käytöstä. Laskutus loppuu automaattisesti eikä sinulta enää veloiteta maksua palvelusta"
                        confirmLabel="Kyllä, haluan lopettaa"
                        cancelLabel="Ei"
                        onCancel={() => setShowConfirm(false)}
                        onConfirm={handleEndService}
                    />
                </div>
            ) : (
                <>
                    {" "}
                    <Row>
                        <Col sm={12} className="order-col">
                            {last_order?.ready && (
                                <Alert
                                    className="order-success-alert"
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        color: "white",
                                        fontSize: "1.2rem",
                                        backgroundColor: "#8184a7",
                                    }}
                                >
                                    Tilauksesi onnistui - seuraa sähköpostiasi
                                </Alert>
                            )}
                        </Col>
                        <Col md={6} sm={12} className="order-col">
                            <OrderInfo />
                        </Col>

                        <Col md={6} sm={12} className="variation-col">
                            {user && user.group && user.group.members && user.group.members.length > 1 ? <Group /> : <Intro onSelect={onSelect} />}
                        </Col>
                    </Row>
                    {(user.appOnly || isActiveSubscription()) && (
                        <Row className="flex-column flex-sm-row align-items-center" style={{ paddingLeft: "1rem" }}>
                            {user.appOnly && (
                                <Col xs={12} sm="auto" className="mb-2 mb-sm-0">
                                    <Button style={{ color: "var(--text-primary)", backgroundColor: "var(--light-background)", border: "none" }} onClick={handleAppRedirect}>
                                        Digihappy sovellukseen
                                    </Button>
                                </Col>
                            )}
                            {isActiveSubscription() && (
                                <Col xs={12} sm="auto">
                                    <button className="button-style" style={{ color: "red" }} onClick={handleShowDialog}>
                                        Lopeta palvelu
                                    </button>
                                </Col>
                            )}
                        </Row>
                    )}
                </>
            )}
        </>
    );
};

export default Order;
